import React from 'react';
import { Navigate } from 'react-router-dom';
import { Core, getPermittedMenuConfig, useAppContext, useEntity, User } from 'connex-cds';
import { get } from 'lodash';
import { useFeatureFlags } from '../../../../../providers/feature-flags-provider';
import { FLAG_LOAD_ASSIGNMENTS } from '../../../../../providers/feature-flags-provider/constants';
import menuConfigFile from '../../menu-config';
import { fetchLandingInputs } from './fetchLandingInputs';
import { resolveLandingDestination } from './resolveLandingDestination';

export const StandaloneLanding = () => {
  const { entityRef } = useEntity();
  const userContext = User.useUserContext();
  const { menuConfig: menuConfigContext } = useAppContext();
  const { getFlagValue, isLoading: isLoadingFlags } = useFeatureFlags() ?? {};
  const [destination, setDestination] = React.useState(null);

  const menuConfig = { ...menuConfigFile, sidebarOptions: menuConfigContext };
  const permittedMenuConfig = getPermittedMenuConfig({ menuConfig, userContext });
  const defaultPath = get(permittedMenuConfig, 'sidebarOptions.0.path', null);
  const loadAssignmentsEnabled = Boolean(getFlagValue?.(FLAG_LOAD_ASSIGNMENTS));

  React.useEffect(() => {
    if (!entityRef || isLoadingFlags) {
      return;
    }

    if (!loadAssignmentsEnabled) {
      setDestination(defaultPath);
      return;
    }

    let cancelled = false;

    const resolveDestination = async () => {
      try {
        const inputs = await fetchLandingInputs(entityRef);
        if (!cancelled) {
          setDestination(`/${resolveLandingDestination(inputs)}`);
        }
      } catch {
        if (!cancelled) {
          setDestination('/load-assignments');
        }
      }
    };

    resolveDestination();

    return () => {
      cancelled = true;
    };
  }, [defaultPath, entityRef, isLoadingFlags, loadAssignmentsEnabled]);

  if (!entityRef || (!loadAssignmentsEnabled && !defaultPath)) {
    return null;
  }

  if (isLoadingFlags || !destination) {
    return <Core.Spinner spin />;
  }

  // Landing sends drivers on to a page they did not pick, so that page may hand them off again.
  return <Navigate to={`/${entityRef}${destination}`} state={{ autoRouted: true }} replace />;
};

export default StandaloneLanding;
